import { Box, Chip, List, ListItem, Paper, Typography } from '@mui/material';
import React from 'react';
import { Comment, getBackgroundColor } from '../../GameTableRow';
import { getRoleName } from '..';
import moment from 'moment';

function CommentDataList({ comments }: { comments: any }) {
  return (
    <div>
      <Paper sx={{ marginTop: 2, padding: 2 }}>
        {comments?.length ? (
          <List>
            {comments
              ?.sort((a: Comment, b: Comment) =>
                a.addedAt < b.addedAt ? 1 : -1
              )
              ?.map((commentData: any) => (
                <ListItem
                  key={commentData?.name}
                  sx={{
                    borderBottom: '1px solid #ccc',
                    marginBottom: '10px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',

                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',

                          gap: 1.2,
                        }}
                      >
                        <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                          {commentData?.name}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{
                            background: getBackgroundColor(commentData?.role),
                            borderRadius: '4px',
                            color: '#000',
                            padding: '0 2px',
                          }}
                        >
                          {`${getRoleName(commentData?.role)}`}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ color: '#888', marginLeft: '15px' }}
                        >
                          {new Date(commentData?.addedAt).toLocaleDateString(
                            'en-GB'
                          )}{' '}
                          {new Date(commentData?.addedAt).toLocaleTimeString(
                            'en-GB',
                            {
                              hour: '2-digit',
                              minute: '2-digit',
                              second: '2-digit',
                            }
                          )}
                        </Typography>
                      </Box>
                      {commentData?.timeDelay && (
                        <Box>
                          <Chip
                            color="error"
                            label={`${moment
                              .duration(commentData?.timeDelay, 'seconds')
                              .asMinutes()}
                            Minute Delay`}
                          />
                        </Box>
                      )}
                    </div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        marginTop: '5px',
                        wordBreak: 'break-all',
                      }}
                    >
                      {commentData?.comment}
                    </Typography>
                  </div>
                </ListItem>
              ))}
          </List>
        ) : (
          <Typography align="center" variant="body2" sx={{ padding: 2 }}>
            No Comments
          </Typography>
        )}
      </Paper>
    </div>
  );
}

export default CommentDataList;
